const authenticatedImageUrls = [
    '/img/IconRawsAgre.png',
    '/img/IconRawsDelete.png',
    '/img/IconRawsFolders.png',
    '/img/IconRawsGift.png',
    '/img/IconRawsHelp.png',
    '/img/IconRawsHola.png',
    '/img/IconRawsLaying.png',
    '/img/IconRawsLaying2.png',
    '/img/IconRawsLearn.png',
    '/img/IconRawsLegal.png',
    '/img/IconRawsMailman.png',
    '/img/IconRawsNiema.png',
    '/img/IconRawsWatermark.png',
    '/img/RawsLogoMiniText.png',
    '/img/messages_icon.jpg',
    '/img/messages_icon.png',
    '/img/no_images.png',
    '/img/rawsInfinity.png',
    '/img/rawsOne.png',
    '/img/rawsUltimate.png',
    '/img/send-raws.png',
    '/img/tempAvatar.jpg',
    '/img/wszyscy.jpeg',
    require('@/assets/Raws_logo_white_NOTagline.svg'),
    require('@/assets/backend/watermark_placeholder.jpg'),
    require('@/assets/dropzone.png'),
    require('@/assets/waitingbg.gif'),
];

let started = false;
const loadingImages: HTMLImageElement[] = [];

export default function preloadAuthenticatedImages() {
    if (started || typeof Image === 'undefined') {
        return;
    }

    started = true;

    authenticatedImageUrls.forEach((src) => {
        const image = new Image();
        image.onload = image.onerror = () => {
            const index = loadingImages.indexOf(image);
            if (index !== -1) {
                loadingImages.splice(index, 1);
            }
        };
        loadingImages.push(image);
        image.src = src;
    });
}
